export default __webpack_public_path__ + "static/media/fishes@3x.5fff7a69.png";